/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FileStorageTypes {
    WindowsShare = 1,
    AzureFileShare = 2,
}
